import React from "react";
import { Modal, StyleSheet, View } from "react-native";
import LoadingIndicator from "./LoadingIndicator";

const Loader = ({ loading, text }) => {
	return (
		<View style={styles.centeredView}>
			<Modal animationType="fade" transparent={true} visible={loading}>
				<View style={styles.centeredView}>
					<LoadingIndicator text={text} />
				</View>
			</Modal>
		</View>
	);
};
const styles = StyleSheet.create({
	centeredView: {
		flex: 1,
		justifyContent: "center",
		alignItems: "center",
		marginTop: 22,
	},
	modalView: {
		margin: 20,
		backgroundColor: "white",
		borderRadius: 20,
		padding: 35,
		alignItems: "center",
		shadowColor: "#000",
		shadowOffset: {
			width: 0,
			height: 2,
		},
		shadowOpacity: 0.25,
		shadowRadius: 4,
		elevation: 5,
	},
	button: {
		borderRadius: 20,
		padding: 10,
		elevation: 2,
	},
	buttonOpen: {
		backgroundColor: "#F194FF",
	},
	buttonClose: {
		backgroundColor: "#2196F3",
	},
	textStyle: {
		color: "white",
		fontWeight: "900",
		textAlign: "center",
	},
	modalText: {
		marginBottom: 15,
		textAlign: "center",
	},
});
export default Loader;
